import { InputLabel, Stack, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { FormTextField } from "UI/FormTextField";

export const Captcha = ({ control, setValue, setError }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [captchaId, setCaptchaId] = useState("");

  const generateSecurityCodeImage = async () => {
    let result;
    setIsLoaded(false);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/get_captcha`,
        {
          method: "GET",
        }
      );
      result = await response.json();
    } catch (error) {
      setError(error);
      return;
    }

    if (!result || result?.error) {
      setError(
        result?.error ?? "Something went wrong. Try to reload the page."
      );
      return;
    }

    setValue("captchaId", result?.captchaId);
    setCaptchaId(result?.captchaId);
    setIsLoaded(true);
  };

  useEffect(() => {
    generateSecurityCodeImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack alignItems={"flex-start"}>
      <InputLabel htmlFor="firstName">Verification Code</InputLabel>
      <Stack direction={"row"} alignItems={"flex-start"} gap={1}>
        <FormTextField
          id="code"
          name="code"
          control={control}
          rules={{ required: "is required" }}
          InputProps={{
            autoComplete: "off",
          }}
        />
        <div className="rounded-md border flex flex-col justify-center items-center border-gray-200 border-solid w-36 h-10">
          {isLoaded ? (
            <Tooltip title="Click to refresh the code">
              <img
                src={`${process.env.REACT_APP_API_V2_URL}/public/captcha/${captchaId}`}
                style={{
                  objectFit: "contain",
                  width: "100px",
                  height: "36px",
                  cursor: "pointer",
                }}
                alt="code"
                onClick={generateSecurityCodeImage}
              />
            </Tooltip>
          ) : (
            <div className="text-sm text-gray-400">Loading...</div>
          )}
        </div>
      </Stack>
    </Stack>
  );
};
